export default {"src":"/_next/static/media/github.4687cf25.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};